import React from "react";
import { observer } from "mobx-react";
import ClockIcon from "../../../../../images/common/clock-grey.svg";
import styled from "styled-components";  
import { FlexContainer, Input, SingleSelect, TimeAMPM, withRouter } from "@mindmemobile/mm-shared-global";

type IProps = {
  hhmm: string;
  amPm: keyof typeof TimeAMPM;
  error: boolean;
  onChange: (amPm: keyof typeof TimeAMPM, time: string) => void;
  className?: string;
};

export const TimezoneWrapper = styled(FlexContainer)`
  .clock-input {
    position: relative;
    .timezone-clock {
      position: absolute;
      top: 50%;
      right: 12px;
      transform: translateY(-59%);
      cursor: pointer;
      img {
        height: 20px !important;
        width: 20px !important;
        /* cursor: pointer; */
      }
    }
  }
  input[type="text"].styled-input {
    width: 110px;
    padding-right: 38px;
    cursor: pointer;
  }
`;

const TimeComponent: React.FC<IProps> = ({
  amPm,
  hhmm,
  error,
  onChange,
  className,
}) => {
  function textInput(
    type: "text",
    key: string,
    value: string | Date,
    placeHolder: string,
    hasError: boolean
  ) {
    return (
      <div>
        <FlexContainer spacing={15} fxLayout="row" className="clock-input">
          <Input
            placeholder={placeHolder}
            type={type}
            value={value}
            error={hasError}
            onChange={(e) => onChange(amPm, e.target.value)}
            className="styled-input"
          />
          <div className="timezone-clock">
            {/* <i className="fa-regular fa-clock"></i> */}
            <img src={ClockIcon} alt="icon" />
          </div>
        </FlexContainer>
      </div>
    );
  }

  const options = Object.keys(TimeAMPM).map((key) => ({
    value: key,
    label: TimeAMPM[key as keyof typeof TimeAMPM],
  }));
  return (
    <TimezoneWrapper spacing={5} className={className}>
      {textInput("text", "time", hhmm, "hh:mm", error)}
      <SingleSelect
        selectedKey={amPm}
        nameKeys={["label"]}
        valueKeys={["value"]}
        options={[options]}
        customOption={(option) => <span>{option.value}</span>}
        onChange={(option: any) =>
          onChange(option.value as keyof typeof TimeAMPM, hhmm)
        }
        searchable={false}
        className="dpdn-no-border"
      />
    </TimezoneWrapper>
  );
};
export default withRouter(observer(TimeComponent));
